module.exports = __webpack_public_path__ + "static/media/NoneInActive.68937962.png";